module.exports = __webpack_public_path__ + "static/media/thompson.b763e09e.png";